export enum OrderStatus {
  New = "New",
  InProgress = "InProgress",
  Complete = "Complete",
  Cancelled = "Cancelled",
  Hold = "Hold",
  Approved = "Approved",
  Rescheduled = "Rescheduled",
  FollowUp = "FollowUp",
  Confirmed = "Confirmed",
  Assigned = "Assigned",
}
